__turbopack_context__.v({
  "OrderOTP_btn": "orderOtp-module__HCg-Oa__OrderOTP_btn",
  "ResendOTPBtn": "orderOtp-module__HCg-Oa__ResendOTPBtn",
  "noSpinButton": "orderOtp-module__HCg-Oa__noSpinButton",
});
